// Clears the subscriber's login cookies and reloads the home page, so every
// component (header, sidebar) re-evaluates the logged-out state.
export function logout(cookie) {
  if (cookie && typeof cookie.keys === 'function') {
    cookie.keys().forEach((key) => cookie.removeCookie(key));
  }
  window.location.href = '/';
}
